(() => {
  "use strict";
  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-pnoe-bf-copy]");
    if (!button) return;
    const code = button.getAttribute("data-pnoe-bf-copy");
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      const original = button.getAttribute("data-pnoe-bf-original") || button.textContent;
      button.setAttribute("data-pnoe-bf-original", original);
      button.textContent = /^el(?:-|$)/i.test(document.documentElement.lang) ? "ΑΝΤΙΓΡΑΦΗΚΕ ✓" : "COPIED ✓";
      window.setTimeout(() => { button.textContent = original; }, 1700);
    } catch (_) {
      button.setAttribute("title", (/^el(?:-|$)/i.test(document.documentElement.lang) ? "Κωδικός: " : "Code: ") + code);
    }
  });
  function runRain() {
    const layer = document.getElementById("pnoe-bf-rain");
    if (!layer || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const code = layer.dataset.code || "";
    const percent = layer.dataset.percent || "";
    const title = layer.dataset.title || "";
    if (!code || !percent) return;
    const elements = layer.dataset.elements || "all";
    const duration = Math.max(3, Math.min(12, Number(layer.dataset.duration) || 7));
    const frequency = Math.max(1, Math.min(4, Number(layer.dataset.frequency) || 2));
    const intensity = layer.dataset.intensity || "medium";
    const key = "pnoe-bf-rain-v2:" + code + ":" + percent;
    const editor = layer.dataset.editor === "true";
    try {
      if (!editor && sessionStorage.getItem(key) === "shown") return;
      sessionStorage.setItem(key, "shown");
    } catch (_) { /* Private browsing can restrict session storage. */ }
    const mobile = window.innerWidth < 740;
    const base = intensity === "low" ? 6 : (intensity === "high" ? 13 : 9);
    const count = Math.min(mobile ? 16 : 52, base * frequency);
    const labels = elements === "percent_only" ? ["−" + percent + "%"] :
      elements === "code_percent" ? [code, "−" + percent + "%"] :
      [code, "−" + percent + "%", title].filter(Boolean);
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < count; i++) {
      const el = document.createElement("span");
      const large = labels[i % labels.length] === title;
      el.className = "pnoe-bf-rain__drop" + (large ? " pnoe-bf-rain__drop--wide" : "");
      el.textContent = labels[i % labels.length];
      el.style.left = (3 + Math.random() * 94).toFixed(2) + "%";
      el.style.fontSize = (mobile ? 9 + Math.random() * 3 : 10 + Math.random() * 6).toFixed(1) + "px";
      el.style.opacity = (0.25 + Math.random() * 0.37).toFixed(2);
      const travelSeconds = Math.min(duration, 2.6 + Math.random() * Math.min(3, duration * 0.38));
      el.style.animationDuration = travelSeconds.toFixed(2) + "s";
      el.style.animationDelay = (Math.random() * Math.max(0, duration - travelSeconds)).toFixed(2) + "s";
      el.style.setProperty("--pnoe-bf-drift", ((Math.random() - 0.5) * 150).toFixed(0) + "px");
      el.style.setProperty("--pnoe-bf-spin", ((Math.random() - 0.5) * 95).toFixed(0) + "deg");
      fragment.appendChild(el);
    }
    layer.appendChild(fragment);
    window.setTimeout(() => layer.replaceChildren(), duration * 1000 + 400);
  }
  // Keep giveaway progress accurate after AJAX cart quantity and discount changes.
  function updateGiveawayFromCart(cart) {
    if (!cart || !Number.isFinite(Number(cart.total_price))) return;
    const total = Number(cart.total_price);
    const cartCurrency = String(cart.currency || "").toUpperCase();
    const count = Number(cart.item_count);
    const locale = /^el(?:-|$)/i.test(document.documentElement.lang) ? "el-GR" : "en-GB";
    const formatter = new Intl.NumberFormat(locale, {style:"currency",currency:"EUR"});
    document.querySelectorAll('[data-pnoe-bf-giveaway="cart"]').forEach((el) => {
      if ((cartCurrency || el.dataset.giveawayCurrency) !== "EUR") return;
      const threshold = Number(el.dataset.giveawayThreshold);
      if (!Number.isFinite(threshold) || threshold < 1) return;
      const status = el.querySelector("[data-giveaway-status]");
      const progress = el.querySelector("[data-giveaway-progress]");
      const eligible = total >= threshold;
      el.dataset.giveawayEligible = String(eligible);
      el.dataset.giveawayTotal = String(total);
      if (status) {
        if (eligible) {
          status.textContent = "✓ " + el.dataset.giveawayEligibleLabel;
        } else if (count === 0) {
          status.textContent = el.dataset.giveawayEmptyLabel;
        } else {
          const remaining = formatter.format((threshold - total) / 100);
          status.textContent = el.dataset.giveawayRemainingLabel + " " + remaining + " " + el.dataset.giveawayRemainingEnd;
        }
        status.classList.toggle("pnoe-bf-giveaway__status-text--yes", eligible);
      }
      if (progress) {
        const pct = Math.max(0, Math.min(100, Math.floor(total / threshold * 100)));
        progress.setAttribute("aria-valuenow", String(pct));
        const fill = progress.querySelector("span");
        if (fill) fill.style.width = pct + "%";
      }
    });
  }
  let cartFetch = null;
  const reloadCartForGiveaway = () => {
    if (cartFetch) return cartFetch;
    const root = window.Shopify?.routes?.root || "/";
    const url = root.replace(/\/?$/, "/") + "cart.js";
    cartFetch = fetch(url, {credentials:"same-origin",cache:"no-store"})
      .then(r => r.ok ? r.json() : null)
      .then(updateGiveawayFromCart)
      .catch(() => {})
      .finally(() => {cartFetch = null;});
    return cartFetch;
  };
  function onGiveawayCartChanged(event) {
    const cart = event.detail?.cart;
    if (cart && Number.isFinite(Number(cart.total_price))) {
      updateGiveawayFromCart(cart);
    } else {
      reloadCartForGiveaway();
    }
  }
  document.addEventListener("cart-update", onGiveawayCartChanged);
  document.addEventListener("cart:updated", onGiveawayCartChanged);
  document.addEventListener("quantity-update", onGiveawayCartChanged);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", runRain, { once: true });
  else runRain();
})();
